<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:54:49
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-16 16:58:38
-->
<template>
  <div>
    <a-spin :spinning="loading">
         <multistageTable ref="tabelBox"/>
    </a-spin>
    <addOrgan :resDataAdd="resDataAdd" :itemAdd="itemAdd" :item="item"  :resData="resData" @close="close" :visible="visible"></addOrgan>
  </div>
</template>

<script>
import addOrgan from './add_organ.vue';
import multistageTable from './multistage_table.vue';
import {organTree} from './organizational_structure'
export default {
  data() {
    return {
      height: 0,
      visible:false,
      resData:[],
      item:{},
      loading:false,
      itemAdd:{},
      resDataAdd:[],
      codeData:[],
    };
  },
  components: {
    multistageTable,
    addOrgan,
  },
  mounted() {
    this.getList();
    this.height = document.documentElement.clientHeight - 419;
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
    window.onresize = () => {
        return (() => {
          this.height = document.documentElement.clientHeight - 419;
        })();
      };
  },
  methods: {
    getList(){
      const that = this;
      organTree({name:''}).then((res)=>{
          if(res.code == 0){
            that.resData = res.data;
          }
      })
    },
    addAdminFn(itemAdd={}){
        this.item = {}
        this.itemAdd = JSON.parse(JSON.stringify(itemAdd));
        const that = this;
        if(this.itemAdd.id){
          organTree({name:'',orgId:itemAdd.id}).then((res)=>{
            if(res.code == 0){
              that.resDataAdd = JSON.parse(JSON.stringify(res.data));
              this.visible = true;
            }
        })
        }else{
           this.visible = true;
        }
    },
    close(){
        this.visible = false;
        this.$nextTick(()=>{
          this.$refs.tabelBox.getOrganTree()
        })
    },
    },
};
</script>

<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #f4f4f6 2px;
  display: flex;
  justify-content: space-between;
  .search {
    display: flex;
    width: 254px;
  }
  /deep/ .ant-select-selection {
    background: #f7f7f7;
  }
  /deep/ .ant-input {
    background: #f7f7f7;
  }
  /deep/ input::-webkit-input-placeholder {
    color: #415058;
  }
  /deep/ .ant-select-selection__placeholder {
    color: #415058;
  }
  .add-img {
    margin-top: -2px;
    margin-right: 3px;
  }
}
.deletBox{
    background: red !important;
   .el-message-box__message{
    color:#ccc !important;
   }
}
.el-button--primary {
  background: #176de6;
}
</style>